module.exports = __webpack_public_path__ + "img/ar.843f9ca4.svg";